import { Component, OnInit, RendererFactory2 } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { ModalComponent } from 'src/app/components/modal/modal.component';
import Swal from 'sweetalert2';
import { UnitOfMeasure } from '../interface';
import { ServicesService } from '../services.service';


@Component({
  selector: 'app-service-units-of-charge',
  templateUrl: './service-units-of-charge.component.html',
  styleUrls: ['./service-units-of-charge.component.scss']
})
export class ServiceUnitsOfChargeComponent extends ModalComponent {
  private unsubscribe$ = new Subject();
  public unitOfMeasure: UnitOfMeasure;
  public unitOfMeasureFormGroup: FormGroup;
  public isLoading: boolean;
  constructor(
    renderFactory: RendererFactory2,
    private router: Router,
    private route: ActivatedRoute,
    private serviceService: ServicesService,
    private fb: FormBuilder,
  ) {
    super(renderFactory);
  }

  onInit(): void {
    this.createFormGroup();
  }

  private createFormGroup() {
    this.unitOfMeasureFormGroup = this.fb.group({
      plural: ['', [Validators.required]],
      singular: ['', [Validators.required]],
    });
  }

  close() {
    this.show = false;
    setTimeout(
      () => this.router.navigate(["."], { relativeTo: this.route.parent }),
      100
    );
  }

  public onSubmit() {
    this.isLoading = true
    this.serviceService.createUnitOfMeasure(this.unitOfMeasureFormGroup.value).subscribe(val => {
      this.close();
      this.isLoading = false
      Swal.fire({
        title: 'Unit of measure successfully created',
        type: 'success',
        timer: 2000
      })
    }, err => {
      this.isLoading = false
      Swal.fire({
        title: "Error",
        text: err.error.message,
        type: "error",
        timer: 2000,
      });
    })
  }

  onDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
